import host from './host'
var apiPath = {
  rankList: host.ydhxgApi8443 + '/ydhxg/LongHuBang/shangbanggegu', // 最新龙虎榜-上榜详情
  rankReason: host.ydhxgApi8443 + '/ydhxg/LongHuBang/shangbangxiangqing', // 个股上榜详情
  branchList: host.ydhxgApi8443 + '/ydhxg/LongHuBang/youzitupu', // 游资图谱列表
  xiWeiTouShi: host.ydhxgApi8443 + '/ydhxg/LongHuBang/xiweitoushi', // 席位透视
  branchRankReason: host.ydhxgApi8443 + '/ydhxg/LongHuBang/yingyebushangbangyuanyin', // 营业部上榜原因
  stockRankReason: host.ydhxgApi8443 + '/ydhxg/LongHuBang/gegushangbangyuanyin', // 个股上榜原因
  branchRankHistory: host.ydhxgApi8443 + '/ydhxg/LongHuBang/yingyebushangbanglishiByPage', // 营业部上榜历史-分页
  xieTongCaoZuo: host.ydhxgApi8443 + '/ydhxg/LongHuBang/xietongcaozuo', // 协同操作
  longHuMiMa: host.ydhxgApi8443 + '/ydhxg/LongHuBang/longhumima', // 龙虎密码-个股列表
  stockSuccessRate: host.ydhxgApi8443 + '/ydhxg/LongHuBang/geguchenggonglv', // 上榜个股成功率
  followYield: host.ydhxgApi8443 + '/ydhxg/LongHuBang/gegugenmaishouyilv', // 个股跟买收益率
  baseinfo: host.zslxt9004 + '/index/assess/baseinfo', //风险测评基本信息
  assStep2: host.zslxt9004 + '/index/assess/step2',
  assStep3: host.zslxt9004 + '/index/assess/step3',
  assStep5: host.zslxt9004 + '/index/assess/step5',
  assStep6: host.zslxt9004 + '/index/assess/step6',
  orgAwk: host.ydhxgApi8443 + '/ydhxg/LongHuBang/jigouzhongcang', // 机构重仓
  gzggList: host.ydhxgApi8443 + '/ydhxg/JiGouDiaoYan/guanzhugegu',  //关注个股
  gzhyList: host.ydhxgApi8443 + '/ydhxg/JiGouDiaoYan/guanzhuhangye',  //关注行业
  yzkdList: host.ydhxgApi8443 + '/ydhxg/JiGouDiaoYan/yizhikanduo',  //一致看多
  zxdyList: host.ydhxgApi8443 + '/ydhxg/JiGouDiaoYan/zuixindiaoyan',  //最新调研
  sctjlineChart: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/gaoguanjingmaishichangtongji',  //高管交易榜--最新交易--折线图
  hyBarChart: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/gaoguanmaimaihangye5',  //高管交易榜--最新交易--柱状图
  zxjyList: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/zuixinjiaoyi',  //最新交易榜--列表
  cxmrBarChart: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/gaoguanmairutianshu5',  //持续买入--柱状图
  cxmrDetail: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/gaoguanmairumingxi',  //持续买入--高管交易明细列表
  cxmrList: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/chixumairu',  //持续买入--列表
  jzmrBarChart: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/gaoguanmairurenshu5',  //集中买入--柱状图
  jzmrList: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/jizhongmairu',  //集中买入--列表
  hytjList: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/hangyetongji',  //行业统计
  sctjList: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/shichangtongji',  //市场统计
  scydtjBarChart: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/jingeyuedutongji',  //市场统计--全市场高管买卖净额月度统计
  hs300BarChart: host.ydhxgApi8443 + '/ydhxg/GaoGuanJiaoYi/hushenindex300',  //市场统计--沪深300指数
  userInfo: host.hxgApi + '/api/hxg/v1/get_user_info', //用户信息
  clickLike: host.ydhxgApi8089 + '/ydhxg/likeAll', // 点赞
  guxiaobaiLike: host.zslxt8089, // 股小白股大咖点赞是否理解接口
  editUser: host.hxgApi + '/api/hxg/v1/edit_user', //修改用户信息
  editPass: host.hxgApi + '/api/hxg/v1/edit_pass', //修改密码
  bkxwList: host.ydhxgApi8443 + '/ydhxg/KanShi/bankuaixinwen',   //板块新闻
  bkggList: host.ydhxgApi8443 + '/ydhxg/KanShi/bankuaigonggao',  //板块公告
  bkybList: host.ydhxgApi8443 + '/ydhxg/KanShi/bankuaiyanbao',  //板块研报
  infoNews: host.ydhxgApi8443 + '/ydhxg/zixun/xinwen', //资讯-新闻
  infoAnnouncement: host.ydhxgApi8443 + '/ydhxg/zixun/gonggao', // 资讯-公告
  infoStudyReport: host.ydhxgApi8443 + '/ydhxg/zixun/yanbao', // 资讯-研报
  infoCaijing: host.ydhxgApi8443 + '/ydhxg/zixun/caijingbaodao',  //财经报道
  infoKuaixun: host.ydhxgApi8443 + '/ydhxg/zixun/kuaixun', //快讯
  infoSsgsxw: host.ydhxgApi8443 + '/ydhxg/zixun/shangshigongsixinwen',  //上市公司新闻
  infoYanjiu: host.ydhxgApi8443 + '/ydhxg/zixun/gongsiyanjiu',  //公司研究
  infoIndus: host.ydhxgApi8443 + '/ydhxg/zixun/hangyeyanjiu',  //行业研究
  getTime: host.ydc + '/node/getTime', //获取服务器时间戳
  accessRecords: host.ydlog + '/accessRecords', //统计
  lishishouyitongji: host.ydhxgApi8443 + '/ydhxg/GeGuLiShiShouYi/lishishouyitongji', //历史收益统计
  ydhxgCDN: host.cdn, // CND 域名
  analysisVideoQues: host.ydhxgApi8089 + '/ydhxg/solutionVideoAsk',
  sendmail: host.yd + host.ydhxgApi8443 + '/tsjywap/sendmail.php', //投诉建议-发送客服邮件接口
  orderMessage: host.zslxtSecure + '/index/message_reminder/save', //订单提醒
  stockRankCalendar: host.ydhxgApi8443 + '/ydhxg/LongHuBang/gegushangbangrili', // 个股上榜日历
  installFinish: host.hxgApi + '/api/hxg/v1/active', // 安装完成统计接口
  videoQuesDecisionMakingCourse: host.ydhxgApi8089 + '/liveClassVideo/decisionMakingCourse', // 直播课提问-决策专属课
  videoQuesPracticalCourse: host.ydhxgApi8089 + '/liveClassVideo/practicalCourse', // 直播课提问-实战直播课
  czStatistics: host.zslxt8089 + '/view', //财源后台统计小白和大咖播放量
  zbjBg: host.tdtg9995 + '/api/rooms' //获取直播间背景图
};
var ydcPath = {
  allIndustry: host.ydhxg + '/hangye',  //最新交易--全部行业
  ztzb_line: host.ydhxg + '/ztzb/line', //涨停/炸版时间列表
  ztzb_list: host.ydhxg + '/ztzb/list', //涨停/炸版表格
  ztzb_tracing: host.ydhxg + '/ztzb/tracing/', //涨停/炸版饼图
  ztzb_brand: host.ydhxg + '/ztzb/sector/list', //板块分析列表
  ReDianJuJiao: host.ydhxg + '/ZhuanJiaFenXi/ReDianJuJiao', //热点聚焦
  PayingUser: host.ydhxg + '/YingXiaoHuoDong/GuangGaoWeiPC/PayingUser', //付费用户广告
  FreeUser: host.ydhxg + '/YingXiaoHuoDong/GuangGaoWeiPC/FreeUser', //免费用户 广告
  ChanPinHuoDong: host.ydhxg + '/YingXiaoHuoDong/ChanPinHuoDong',
  XiaoBaiKeTang: host.ydhxg + '/XiaoBaiKeTang', //小白课堂
  ZaoZhiXiao: host.ydhxg + '/ZaoZhiXiao', //早知晓
  classes: host.zbj + '/zbjcc/hxgzbj/classes', //慧选股直播间课程列表
  JiePanShiPin: host.ydhxg + '/ZhuanJiaFenXi/JiePanShiPin', //解盘视频 音频
  JiePanShiPinVideo: host.ydhxg + '/ZhuanJiaFenXi/JiePanShiPinVideo', //解盘视频 视频
  liveLesson: host.ydhxg + '/ZhuanJiaFenXi/ZhiBoKeTangVideo', // 直播课节点
  vpLive: host.ydhxg + '/ZhuanJiaFenXi/GuanDianZhiBo', //观点直播 - 最近交易日
  viewPointLive: host.ydhxg + '/ZhuanJiaFenXi/GuanDianZhiBo', // 观点直播
  hotFocus: host.ydhxg + '/ZhuanJiaFenXi/ReDianJuJiao', // 热点聚焦
  viewPointLike: host.ydhxg + '/Users', // 观点直播点赞
  xbktCourse: host.ydhxg + '/XiaoBaiKeTangFour',  //成长--小白课堂
  xbktCourse2: host.ydhxg + '/XiaoBaiKeTang',  //成长--小白课堂--无套系
  Taoxi: host.cygp + '/TaoXi',  //成长--套系
  DkllCourse: host.ydhxg + '/DaKaLaiLe',  //成长--大咖来了
  clxtCourse: host.ydhxg + '/ChengZhangKeTang',  //策略学堂
  zbxxCourse: host.ydhxg + '/ZhiBiaoKeTang',  //指标学习
  ZhiBiaoKeTangAll: host.ydhxg + '/ZhiBiaoKeTangAll',  //指标课堂-用户中心弹窗用
  ChengZhangKeTangAll: host.ydhxg + '/ChengZhangKeTangAll',  //策略课堂-用户中心弹窗用
  clxtTxIntro: host.ydhxg + '/CeLueTaoXiJieShao',  //策略学堂套系介绍
  zbxxTxIntro: host.ydhxg + '/ZhiBiaoTaoXiJieShao',  //指标学习套系介绍
  orderList: host.cem + '/zorders', //订单列表
  // tszbList: host.ydhxg + '/TeSeZhiBiaoResult',  //获取特色指标列表项
  clylIntro: host.ydhxg + '/CeLueJieShao',  //策略原理相关介绍
  earlyKnow: host.ydhxg + '/ZaoZhiXiao', // 早知晓列表
  jzclFiveUpdate: host.ydhxgApi8443 + '/quote_provider_yun/',  //价值策略每五分钟实时更新
  tszbTeacherSel: host.ydhxg + '/TeSeZhiBiaoTeacherCondition/baimaijiyou',  //资金揭秘--老师选的特色指标列表
  rdjjList: host.ydhxg + '/ZhuanJiaFenXi/ReDianJuJiao',  //热点主题--热点聚焦
  ztbkList: host.ydhxg + '/ZhuTiTouZi/ZhuTiBanKuai',  //主题投资--主题板块
  lhzjTszb: host.ydhxg + '/TeSeZhiBiaoCondition',  //资金揭秘--特色指标
  zttzXgfw: host.ydhxg + '/ZhuTiTouZi/ZhuTiTouZiNew',  //主题投资--选股范围
  rdfkXgfw: host.ydhxg + '/ReDianFengKou/ReDianFengKouNew',  //热点风口--选股范围
  zztzMoreFive: host.ydhxg + '/ZhuTiTouZi/ZhuTiTouZiFive',  //主题投资五个跟更多热点板块
  rdfkMoreFive: host.ydhxg + '/ReDianFengKou/ReDianFengKouFive',  //热点风口五个跟更多热点板块
  clCzktList: host.ydhxg + '/ChengZhangXueTang',  //策略模块成长学堂系列
  ztbkDetail: host.ydhxg + '/ZhuTiTouZi/ZhuTiBanKuai/', //主题板块详情
  praisePath: host.ydhxg + '/ChengZhangKeTang1/CeLueXueTangLikeAll',  //策略学堂--点赞总数
  ifPraisePath: host.ydhxg + '/Users',  //策略学堂--是否点赞
  historyTime: host.ydhxg + '/CeLueZhongXin/CeLueLiShi',  //历史战绩榜时间获取
  hybkTreemap: host.ydhxg + '/CeLueZhongXin/HangYeBanKuai',  //热点主题--行业板块树图
  tszbIntro: host.ydhxg + '/TeSeZhiBiaoJieShao',  //特色指标介绍
  tszbCzkt: host.ydhxg + '/ZhiBiaoXueTang',  //特色指标--成长课堂
  // onCelueChange: host.ydhxg + '/CeLueZhongXin/UpdateFlag/biangegn',  //监听策略系列数据变化
  onCelueChange: host.ydhxg + '/CeLueZhongXin/UpdateFlag',  //监听热点策略数据变化
  openningCalendar: host.ydhxg + '/openning_calendar_before', // 最近一年交易日
  XiaoXiZhongXin: host.ydhxg + '/XiaoXiZhongXin', //消息中心
  GongGaoGuanLi: host.ydhxg + '/GongGaoGuanLi', //公告推送
  klineVideo: host.ydhxg + '/ZhiBiaoXueTang', //日线学指标视频弹窗节点
  onZhuTiCelueChange: host.ydhxg + '/CeLueZhongXin/ZhuTiCeLue/xuangufanwei', //监听主题策略数据变化
  chanPinFuWu: host.ydhxg + '/YingXiaoHuoDong/ChanPinFuWu', //个人中心-服务
};
var otherPath = {
  jzclTableList: host.ydhxgApi9091 + '/celuexuangu/getjiazhicelue',  //价值策略
  mxfxList: host.ydhxgApi9091 + '/celuexuangu/getmingxingfenxi',  //研报策略--明星分析推荐
  mxjgList: host.ydhxgApi9091 + '/celuexuangu/getmingxingjigou',  //研报策略--明细机构
  zfkjList: host.ydhxgApi9091 + '/celuexuangu/getzhangfukongjian',  //研报策略--涨幅空间最大
  gczHistory: host.ydhxgApi9091 + '/celuexuanguRes20/gaoChengZhangRes20',  //历史战绩榜--高成长
  dgzHistory: host.ydhxgApi9091 + '/celuexuanguRes20/diGuZhiRes20',  //历史战绩榜--低估值
  bmjyHistory: host.ydhxgApi9091 + '/celuexuanguRes20/baiMaJiYouRes20',  //历史战绩榜--白马绩优
  gfhHistory: host.ydhxgApi9091 + '/celuexuanguRes20/gaoFenHongRes20',  //历史战绩榜--高分红
  gylHistory: host.ydhxgApi9091 + '/celuexuanguRes20/gaoYingLiRes20',  //历史战绩榜--高盈利
  // gyyHistory: host.ydhxgApi9091 + '/celuexuanguRes20/gaoYunYingRes20',  //历史战绩榜--高运营
  yjyzHistory: host.ydhxgApi9091 + '/celuexuanguRes20/yeJiYuZengRes20',  //历史战绩榜--业绩预增
  gszHistory: host.ydhxgApi9091 + '/celuexuanguRes20/xianJinNiuRes20',  //历史战绩榜--高送转
  gdzcHistory: host.ydhxgApi9091 + '/celuexuanguRes20/zengChiHuiGouRes20',  //历史战绩榜--股东增持
  rdfkoneHistory: host.ydhxgApi9091 + '/celuexuanguRes20/reDianFengKouOneRes20',  //历史战绩榜--热点风口--底部买一
  // rdfktwoHistory: host.ydhxgApi9091 + '/celuexuanguRes20/reDianFengKouTwoRes20',  //历史战绩榜--热点风口--底部买二
  // rdfkzslHistory: host.ydhxgApi9091 + '/celuexuanguRes20/reDianFengKouThreeRes20',  //历史战绩榜--热点风口--主升浪
  zttzoneHistory: host.ydhxgApi9091 + '/celuexuanguRes20/zhuTiTouZiOneRes20',  //历史战绩榜--主题投资--底部买一
  // zttztwoHistory: host.ydhxgApi9091 + '/celuexuanguRes20/zhuTiTouZiTwoRes20',  //历史战绩榜--主题投资--底部买二
  // zttzzslHistory: host.ydhxgApi9091 + '/celuexuanguRes20/zhuTiTouZiThreeRes20',  //历史战绩榜--主题投资--主升浪
  rdfkOneList: host.ydhxgApi9091 + '/celuexuangu/getredianfengkou1',  //热点风口--底部买一
  rdfkTwoList: host.ydhxgApi9091 + '/celuexuangu/getredianfengkou2',  //热点风口--底部买二
  rdfkZslList: host.ydhxgApi9091 + '/celuexuangu/getredianfengkou3',  //热点风口--主升浪
  zttzOneList: host.ydhxgApi9091 + '/celuexuangu/zhititouzi1',  //主题投资--底部买一
  zttzTwoList: host.ydhxgApi9091 + '/celuexuangu/zhititouzi2',  //主题投资--底部买二
  zttzZslList: host.ydhxgApi9091 + '/celuexuangu/zhititouzi3',  //主题投资--主升浪
  ztclxg: host.ydhxgApi9091 + '/celuexuangu/ztclxg',  //主题投资--主升浪
  lhzjList: host.ydhxgApi9091 + '/celuexuangu/getlonghuzijin',  //资金揭秘--龙虎资金
  ggzjList: host.ydhxgApi9091 + '/celuexuangu/getgaoguanzijin',  //资金揭秘--高管资金
  zlzjList: host.ydhxgApi9091 + '/celuexuangu/getzhulizijin',  //资金揭秘--主力资金
  fundSummary: host.ydhxgApi9091 + '/celuexuangu/fundSummary',  //资金揭秘
  ziJinJieMiRes20: host.ydhxgApi9091 + '/celuexuanguRes20/ziJinJieMiRes20' //历史战绩榜-资金揭秘
}
var appPath = {
  android: 'http://s.img.zslxt.com/download/hxg-yd-release.apk',
  ios_pc: 'http://s.img.zslxt.com/download/hxg-yd-release.ipa',
  ios: 'itms-services:///?action=download-manifest&url=https://yd.com.cn/hxg-iosapp.plist',
  pc: 'http://s.img.zslxt.com/download/ydhxgv1.1.0.25.exe',
  pcxp: 'http://s.img.zslxt.com/download/ydhxgv1.1.0.25forxp.exe'
}

export { apiPath, ydcPath, otherPath, appPath};



// WEBPACK FOOTER //
// ./src/api/service.js